export function getAdminShadowSettingsRedirectPath(
  pathname: string,
  imei: string,
  scopedTenantId: string | undefined,
  role: string | null,
): string | null {
  if (role !== "super_admin" || pathname.startsWith("/admin/") || !scopedTenantId) {
    return null;
  }

  const params = new URLSearchParams({
    tenantId: scopedTenantId,
    returnTo: "/admin/devices",
  });
  return `/admin/devices/${encodeURIComponent(imei)}/shadow-settings?${params.toString()}`;
}
